import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateIsInThePast'
})
export class DateIsInThePastPipe implements PipeTransform {
  transform(date: Date | string | number): boolean {
    if (!date) return false;
    const inputDate = moment.utc(date);
    return inputDate.isBefore(moment.utc());
  }
}
